<template>
  <form data-abide2 novalidate data-vv-scope="form4" @submit.prevent="goToStep5" dusk="registration-step-4" class="step"  :style="{'justify-content':buttonToTop ? 'flex-start' : 'center','flex-flow' : buttonToTop ? 'column' : 'wrap'}">
      <div class="form-inner">
        <div class="headline" v-html="trans('reg.choose_password')"></div>
        <label class="password-container">
          <input class="form-control dark"
                 :type="showpassword ? 'text' : 'password'"
                 ref="password_input"
                 id="password"
                 v-bind:placeholder="trans('password')"
                 v-bind:data-vv-as="trans('password').toLowerCase()"
                 required
                 v-model="password"
                 v-validate="'required|min:6'"
                 :class="{'is-invalid-input': errors.has('form4.password')}"
                 name="password" />
          <div @click="showpassword = !showpassword" class="hide-password" :class="{'show' : !showpassword}"></div>
          <p v-if="!password" class="text-mute">{{trans('reg.password_description')}}</p>
          <p class="text-mute password-success" v-if="password !== '' && !errors.has('form4.password')">{{trans('reg.password_looks_good')}}</p>
          <span class="form-error" :class="{'is-visible': errors.has('form4.password')}">
            {{ errors.first('form4.password') }}
          </span>
        </label>
      </div>
      <div class="form-footer">
        <button :disabled="!password || errors.has('form4.password')" class="btn btn-primary btn-long btn-rounded" id="button4" type="submit">
          {{ trans('reg.next') }}
        </button>
      </div>
  </form>
</template>

<script>
import DatePickerComponent from '@buddy/views/widgets/DatePickerComponent.vue';

export default {
  mixins: [require('@general/lib/mixin').default],
  props: ['vars'],
  data() {
    return this.vars;
  },
  components: {
    DatePickerComponent,
  },
  methods: {
    async goToStep5() {
      this.showLoadingButton('#button4')
      let response = await axios.post('/api/register/validate-password', {password: this.password})
      if (response.data.success) {
        //for browser remember password alert
        this.step = 5;
      }else{
        this.errors.add({
          field: 'form4.password',
          msg: response.data.errors.password[0]
        });
      }
      this.restoreLoadingButton('#button4')
    },
  },
  mounted() {
    let password = document.getElementById('password');

    let self = this;
    if(this.isMobile){
      password.addEventListener("focus", () => {
        self.buttonToTop = true;
      })
      password.addEventListener("blur", () => {
        self.buttonToTop = false;
      })
      document.getElementById('button4').addEventListener('touchend', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(!(!this.password || this.errors.has('form4.password'))){
          this.goToStep5()
        }
      });
    }

    if(this.buttonToTop || this.isDesktop){
      this.$nextTick(() => this.$refs.password_input.focus())
    }
  },
}
</script>
